import React from 'react'
import { Slider as MUISlider, Box, Typography } from '@mui/material'
import { styled } from '@mui/system'
import palette from 'core-system/Themes/palette'
import FormattingUtils from 'shared/FormattingUtils'

const Container = styled(Box)({
  width: '100%',
})

interface SliderProps {
  min?: number
  max?: number
  step?: number
  startPoint?: number
  onChange?: (value: number) => void
  minLabel?: string
  maxLabel?: string
}

const Slider = React.memo(
  ({
    min = 1,
    max = 100,
    step = 1,
    startPoint = 1,
    onChange,
    minLabel,
    maxLabel,
  }: SliderProps) => {
    return (
      <Container
        sx={{
          '& .MuiBox-root': {
            marginBottom: 0,
          },
          '& .MuiSlider-root': {
            padding: '5px 0px !important',
          },
        }}
      >
        <Box display='flex' justifyContent='space-between' mb={1}>
          <Typography
            variant='caption'
            style={{ fontWeight: 600 }}
            color={palette.text.placeholder}
          >
            {minLabel || FormattingUtils.formatDollar(min, 0)}
          </Typography>
          <Typography
            variant='caption'
            style={{ fontWeight: 600 }}
            color={palette.text.placeholder}
          >
            {maxLabel || FormattingUtils.formatDollar(max, 0)}
          </Typography>
        </Box>
        <MUISlider
          defaultValue={startPoint}
          min={min}
          max={max}
          step={step}
          sx={{
            '& .MuiSlider-track': {
              color: palette.secondary.purple600,
              height: 6, // Increased track height
            },
            '& .MuiSlider-rail': {
              backgroundColor: palette.grey.grey400,
              height: 6, // Increased rail height
            },
            '& .MuiSlider-thumb': {
              width: 18, // Reduced from 24
              height: 18, // Reduced from 24
              backgroundColor: palette.white,
              border: `0.25rem solid ${palette.secondary.purple600}`,
              '&:hover': {
                boxShadow: 'none',
              },
            },
          }}
          onChange={(_, value) => onChange?.(value as number)}
        />
      </Container>
    )
  }
)

if (process.env.NODE_ENV !== 'production') {
  Slider.displayName = 'Slider'
}

export default Slider
